let intialState = {
    notifications: []
}

export default function notificationReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case 'Get_Notifications':
            if (action.payload.length > 0) {
                stateCopy.notifications = action.payload;
                stateCopy.isLoading = false;
            }
            else {
                stateCopy.isLoading = false;
            }
            return stateCopy;
        case 'Get_Next_Notifications':
            if (action.payload.length > 0) {
                stateCopy.notifications = stateCopy.notifications.concat(action.payload);
                stateCopy.isLoading = false;
            }
            else {
                stateCopy.isLoading = false;
            }
            return stateCopy;
        case 'Notification_Marked_Read':
            window.location.href = action.payload;
            return stateCopy;
        default:
            return stateCopy;

    }
}